"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var dropdown_styles_1 = require("./dropdown.styles");
var filterLink_1 = require("./filterLink/filterLink");
var check_icon_1 = require("../../icons/check.icon");
var analyticsService_1 = require("../../analytics/analyticsService");
var useClickOutside_1 = require("../../hooks/useClickOutside");
var optionHeight = 40;
function Dropdown(props) {
    var selectNode = react_1.default.useRef(null);
    var _a = react_1.default.useState(props.forceExpanded), showOptions = _a[0], setShowOptions = _a[1];
    var _b = react_1.default.useState(props.selectedValue), selected = _b[0], setSelected = _b[1];
    function toggleOptions() {
        setShowOptions(!showOptions);
    }
    useClickOutside_1.useClickOutside(selectNode, function () { return setShowOptions(false); });
    react_1.useEffect(function () {
        if (props.selectedValue !== selected) {
            setSelected(props.selectedValue);
        }
    }, [props.setSelectedValue]);
    var optionsClass = props.showOnLeft ? dropdown_styles_1.optionsLeft : dropdown_styles_1.options;
    var layoutClass = props.stretchWidth
        ? dropdown_styles_1.dropdownStretch(props.stretchWidth)
        : dropdown_styles_1.dropdownContainer;
    var containerClass = props.stretchWidth ? dropdown_styles_1.containerStretch : dropdown_styles_1.container;
    var top = optionHeight;
    function selectOptionAndClose(option) {
        setSelected(option.id);
        setShowOptions(false);
        analyticsService_1.AnalyticsService.recordEvent("select-" + props.id + "-dropdown");
        props.setSelectedValue(option.id);
    }
    var selectedOption = props.options.find(function (option) { return option.id === selected; });
    return (react_1.default.createElement("div", { className: layoutClass, ref: selectNode },
        react_1.default.createElement("div", { onClick: props.disabled ? null : toggleOptions, className: containerClass, id: props.id + "-list" }, props.children ? (props.children) : (react_1.default.createElement(filterLink_1.FilterLink, { id: props.id, disabled: props.disabled, filterText: props.displayName, defaultValue: props.defaultValue, selectedValue: selectedOption && selectedOption.displayName, isShowingOptions: showOptions }))),
        showOptions && (react_1.default.createElement("div", { className: optionsClass, style: { top: top }, id: props.id + "-options" }, props.options.map(function (option, index) { return (react_1.default.createElement(DropdownOption, { key: index, displayName: option.displayName, value: option.value, id: option.id, isSelected: selected ? option.id === selected : false, setSelected: selectOptionAndClose })); })))));
}
exports.Dropdown = Dropdown;
var DropdownOption = function (props) {
    function setSelected() {
        var option = {
            id: props.id,
            displayName: props.displayName,
            value: props.value,
        };
        props.setSelected(option);
    }
    return (react_1.default.createElement("div", { onClick: function () { return setSelected(); }, className: dropdown_styles_1.optionClass, id: props.id.toString(), "data-qa": "dropdown-option", "data-qa-selected": props.isSelected.toString(), "data-qa-value": props.value },
        props.displayName,
        " ",
        props.isSelected && react_1.default.createElement(check_icon_1.CheckIcon, null)));
};
